import { Menu as AntMenu } from 'antd';
import { MenuItemProps as AntMenuItemProps } from 'antd/lib/menu/MenuItem';

type MenuItemProps = {
  // TODO
};

const MenuItem = (props: MenuItemProps & AntMenuItemProps) => {
  return <AntMenu.Item {...props} className="menu-item" />;
};

export default MenuItem;
